import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import React from 'react';

interface ModalState {
  isOpen: boolean;
  component: React.FC<any> | null; // Компонент модального окна
  context: any;                   // Данные для компонента
}

const initialState: ModalState = {
  isOpen: false,
  component: null,
  context: null,
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<{ component: React.FC<any>; context: any }>) => {
      state.isOpen = true;
      state.component = action.payload.component;
      state.context = action.payload.context;
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.component = null;
      state.context = null;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;